import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import robot from '../not-found-page/robot.png';

import ErrorSnackbar from '@components/auth/layouts/authenticated/error-snackbar';
import Logo from '@icons/logo';
import classes from './site-error.scss';

const ErrorPage = ({publicPage = false}) => (
  <Fragment>
    <div className={classes.pageErrorContainer}>
      <img src={robot} alt="robot" />
      <div className={classes.pageErrorHeader}>
        An Error Occurred
      </div>
      <div className={classes.pageErrorBody}>
        Sorry, the page could not be loaded.<br/>
        Wait a few moments and refresh the page to try again.
      </div>
      {publicPage ?
        <Logo /> :
        <a href="/">
          <Logo title="Go to main page"/>
        </a>
      }
    </div>
    <ErrorSnackbar />
  </Fragment>
);

ErrorPage.propTypes = {
  publicPage: PropTypes.bool
};

export default ErrorPage;
